import NoTeachingPeriodContainer from './NoTeachingPeriodContainer';
export default NoTeachingPeriodContainer;
